import React, { useEffect, useState, useRef, useContext } from "react";
import { useCurrentUserHook } from "../../Authentication/useUserHook";
import DynamicForm from "../../FormBuilder/DynamicForm";
import FormContainer from "../../FormBuilder/FormContainer";
import UiSettingService from "./UiSettingService";
import { CacheContext } from "../../../contexts/Cache/CacheStateProvider";

function OrgUiSettingsForm(props) {
  const formId = 1251;
  const { currentUser } = useCurrentUserHook();
  const { cacheState } = useContext(CacheContext);

  let { current: scope } = useRef({
    formMode: null,
    form: {},
    data: {},
    formFn: {}
  });

  const [isFormRendered, setFormRendered] = useState(false);
  const [post, setPost] = useState({});

  const params = props.match.params;

  const get = async (id) => {
    const { status, data } = await UiSettingService.get(id);
    if (status === 200) {
      scope.form = data;
      scope.data = scope.form.data;
      setFormRendered(true);
    }
  };

  useEffect(() => {
    scope.formFn = { "form_type": "org_ui_setting", "editPermission": true };

    const id = params?.id ?? cacheState?.activeUISetting?.id;

    if (id) {
      scope.formMode = "edit-form-submissions";
      get(id);
    } else {
      scope.formMode = "create-form-submissions";
      if (!isFormRendered) setFormRendered(true);
    }
  }, [cacheState]);

  const create = async (form) => {
    form.form_id = formId;
    form.organization_id = currentUser.current_organization_id;

    const { status, data } = await UiSettingService.create(form);
    if (status === 201) {
      onSubmit(data.org_ui_setting);
    }
  };

  const update = async (form) => {
    const { status } = await UiSettingService.update(form);
    if (status === 204) {
      onSubmit(form);
    }
  };

  const onSubmit = (form) => props.onSubmit(form);
  const onCancel = () => props.toggleModal();

  if (isFormRendered) {
    return (
      <FormContainer post={post} isPopupMode={props.isPopupMode}>
        <DynamicForm
          formMode={scope.formMode}
          formId={formId}
          form={scope.form}
          data={scope.data}
          formFn={scope.formFn}
          onCreate={create}
          onUpdate={update}
          post={post}
          onCancel={onCancel}
          setPost={setPost}
          isPopupMode={props.isPopupMode}
        />
      </FormContainer>
    );
  }

  return null;
}

export default OrgUiSettingsForm;
